// extracted by mini-css-extract-plugin
export default {"addButtonContainer":"DashboardContent_addButtonContainer__Q7t7u","addButton":"DashboardContent_addButton__a40bS","footerButtons":"DashboardContent_footerButtons__3Ok7k"};